module.exports = __webpack_public_path__ + "8f359d6c42688fa96ccf01b675287741.png";